import React, { useState, createRef, memo } from "react";
import PropTypes from "prop-types";
import SpeechModule from "../SpeechModule";
import "./css/chatForm.css";

const ChatForm = ({
  addChat,
  addVoiceResponse,
  isPizzaBuilder,
  speechEnabled
}) => {
  const [value, updateInputStateValue] = useState("");
  const textInput = createRef();

  const updateInput = evt => {
    /* START CORE-12106 */
    if (isPizzaBuilder) {
      window.parent.postMessage(
        {
          action: "chat-input-change"
        },
        window.ENVCONFIG.root
      );
    }
    /* END CORE-12106 */

    updateInputStateValue(evt.target.value);
  };

  /* START CORE-12106 */
  const handleFocus = () => {
    if (isPizzaBuilder) {
      window.parent.postMessage(
        {
          action: "chat-input-focus"
        },
        window.ENVCONFIG.root
      );
    }
  };
  /* END CORE-12106 */

  const recieveSpeechInput = value => {
    textInput.focus();
    updateInputStateValue(value);
  };

  const sendSpeechInput = (value, author) => {
    textInput.focus();
    updateInputStateValue(value);
    addVoiceResponse(value, author);
  };

  return (
    <div data-quid="chat-input" className="chat__input">
      <div className="chat__input__container">
        <form
          data-quid="chat-input-form"
          className="chat__input__form"
          action=""
          onSubmit={evt => addChat(evt)}
        >
          <label htmlFor="chat__input__form" aria-label="New Chat">
            <span className="chat__input__form__label-text">New Chat</span>
            <input
              data-quid="chat-input-field"
              ref={textInput}
              id="chat__input__form"
              className="chat__input__form__text ctHidden"
              type="text"
              placeholder="Type a message..."
              name="newChat"
              autoComplete="off"
              autoFocus
              value={value || ""}
              onChange={updateInput}
              /* START CORE-12106 */ onFocus={handleFocus} /* END CORE-12106 */
            />
          </label>
        </form>
        <div className="chat__input__speech">
          {speechEnabled && (
            <SpeechModule
              displaySpeechResponse={recieveSpeechInput}
              sendSpeechResponse={sendSpeechInput}
            />
          )}
        </div>
      </div>
    </div>
  );
};

ChatForm.propTypes = {
  speechEnabled: PropTypes.bool.isRequired,
  addChat: PropTypes.func.isRequired,
  addVoiceResponse: PropTypes.func.isRequired,
  // eslint-disable-next-line
  value: PropTypes.string /* START CORE-12106 */,
  isPizzaBuilder: PropTypes.bool.isRequired
  /* END CORE-12106 */
};

ChatForm.defaultProps = {
  value: ""
};

export default memo(ChatForm);
